import * as ActionTypes from '../constants/actionTypes';

export const initialState = {
    request: false,
    error: '',
    data: [],
};

export default function bestOffer(state = initialState, action) {

    switch (action.type) {
        case ActionTypes.BEST_OFFER_REQUEST:
            return {
                ...state,
                request: true,
                error: '',
            };

        case ActionTypes.BEST_OFFER_SUCCESS:
            return {
                ...state,
                request: false,
                error: '',
                data: action.payload
            };

        case ActionTypes.BEST_OFFER_ERROR:
            return {
                ...state,
                request: false,
                error: action.payload
            };

        default :
            return state;
    }

}